'use strict';

var DemandTransparencyForecastDataGridMappedTransformerFactory = function DemandTransparencyForecastDataGridMappedTransformerFactory(DataTransformer) {
  function DemandTransparencyForecastDataGridMappedTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-forecast-profile-mapped';
    this.targetType = 'demand-transparency-forecast-data';
    this.priority = 1;
  }
  DemandTransparencyForecastDataGridMappedTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyForecastDataGridMappedTransformerFactory.constructor = DemandTransparencyForecastDataGridMappedTransformerFactory;
  return DemandTransparencyForecastDataGridMappedTransformerFactory;
};
DemandTransparencyForecastDataGridMappedTransformerFactory.$inject = ['DemandTransparencyForecastDataGridRegularTransformerFactory'];
module.exports = DemandTransparencyForecastDataGridMappedTransformerFactory;